import { redirect, type RouteObject } from 'react-router';

import ProfilePage from 'src/pages/Settings/Profile';
import OrganizationPage from 'src/pages/Settings/Organization';
import BillingPage from 'src/pages/Settings/Billing';
import { SettingsLayout } from 'src/pages/Settings/ui';
import { SettingsRoutesEnum } from 'src/pages/Settings/model';

export const settingsRoutes: RouteObject = {
  element: <SettingsLayout />,
  path: 'settings/*',
  loader: async ({ params }) => {
    const { '*': path = '' } = params;

    if (!path) return redirect('/settings/profile');
    if (!Object.values(SettingsRoutesEnum).includes(path as SettingsRoutesEnum)) return redirect('/404');
    return null;
  },
  children: [
    {
      path: SettingsRoutesEnum.Profile,
      element: <ProfilePage />,
    },
    {
      path: SettingsRoutesEnum.Organization,
      element: <OrganizationPage />,
    },
    {
      path: SettingsRoutesEnum.Billing,
      element: <BillingPage />,
    },
  ],
};
